import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=284adbdb"
import script from "./ImageGallery.vue?vue&type=script&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&lang=ts"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=284adbdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports